// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {}

.dashboard-page-container {
  background-color: #e8effa;
  display: flex;
  flex-direction: row;
  height: 100vh;
  overflow: hidden;
}

.dashboard-page-container .sidebar {
  width: 250px;
  min-width: 100px;
  background-color: #fcfdfe;
  padding: 20px;
  color: #212121;
  transition: transform 0.3s ease;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
  overflow-y: auto;
  top: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
}

.new-chat-button {
  background: #279DD9 !important;
  border: none;
  border-radius: 5px;
  box-sizing: border-box;
  color: #fff;
  cursor: pointer;
  flex-direction: row;
  font-size: 12px;
  justify-content: center;
  outline: none;
  padding: 10px;
  margin-top: 10px;
  position: relative;
  text-align: center;
  transition: all .15s ease;
}

.sidebar-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
}

.sidebar-logo {
  width: 66%;
}

/* Updated content layout */
.content {
  flex-grow: 1;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  padding: 20px;
  padding-bottom: 0px;
  max-width: none;
  width: 100%;
}

.dashboard-content {
  flex: 1 1;
  min-width: 200px;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  padding-right: 20px;
}

.sidebar-item {
  margin-bottom: 20px;
}

.workgroup-dropdown label {
  display: block;
  font-weight: bold;
  margin-bottom: 10px;
}

.workgroup-dropdown select {
  width: 100%;
  padding: 8px 12px;
  font-size: 14px;
  border: 1px solid #ddd;
  border-radius: 6px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  background-color: white;
  color: #212121;
  outline: none;
}

.workgroup-dropdown select:focus {
  ring: 2px;
  ring-color: #279DD9;
  ring-opacity: 0.5;
  border-color: #279DD9;
}

.workgroup-dropdown select:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.button {
  background-color: #007bff;
  color: white;
  padding: 10px 20px;
  border: none;
  cursor: pointer;
}

.button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.error-message {
  color: red;
  font-size: 14px;
}

.dropdown-button {
  position: fixed; /* Change to fixed */
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 20px;
  color: grey;
  cursor: pointer;
  padding: 5px;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  right: 0;
  background-color: #333;
  border-radius: 5px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  padding: 10px;
  z-index: 25;
}

.dropdown-item {
  background: none;
  border: none;
  color: white;
  padding: 8px 16px;
  text-align: left;
  width: 100%;
  cursor: pointer;
}

.dropdown-item:hover {
  background-color: #555;
}

.chat-container {
  flex-grow: 1;
  padding-right: 0;
  overflow-y: auto;
  padding-bottom: 10px;
  width: 100%;
  font-family: 'Hind';
  line-height: 24px;
}

.messages-container {
  overflow-y: auto;
  flex-grow: 1;
  padding: 10px;
  height: calc(100vh - 150px);
  width: 100%;
  min-width: 200px;
  z-index: 10;
}

.input-container {
  padding: 10px;
  bottom: 10px;
  display: flex;
  position: relative;
  width: 100%;
}

.input-box {
  border-radius: 15px;
}

.internal-content {
  position: relative;
  min-width: 250px;
  width: 350px;
  max-width: 100%;
  height: calc(100vh - var(--topnav-height, 56px) - 70px);
  margin-top: 10px;
  border-left: 1px solid rgb(147, 200, 207);
  box-sizing: border-box;
  overflow: visible;
  resize: horizontal;
  padding: 15px;
  display: flex;
  flex-direction: column;
}

.internal-messages-container {
  width: calc(100% - 2px); /* Account for borders */
  height: 40%;
  border: 1px solid #ccc;
  background-color: #f9f9f9;
  border-radius: 8px;
  padding: 15px;
  overflow-y: auto;
  margin-bottom: 15px;
  font-size: 13px;
}

.system-prompt-input {
  width: calc(100% - 2px); /* Match internal messages width */
  height: calc(60% - 15px);
  display: flex;
  flex-direction: column;
}

.internal-content::-webkit-resizer {
  padding-right: 10px; /* Add some padding to separate from scrollbar */
}

.internal-content {
  resize: horizontal;
  padding-right: 5px;
}

.internal-messages-container {
  margin-right: 2px; /* Add small margin to prevent overlap */
}

.system-prompt-input-box {
  width: 100%;
  height: calc(100% - 55px); /* Leave space for buttons */
  resize: none;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 8px;
  font-size: 13px;
  overflow-y: auto;
  margin-bottom: 15px;
}

.system-prompt-buttons {
  width: 100%;
  height: 40px;
  display: flex;
  justify-content: space-between;
  gap: 10px;
  margin-top: auto;
}

.system-prompt-submit,
.ranking-button {
  flex: 1 1;
  height: 40px;
  padding: 8px 15px;
  background-color: #279DD9;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
}

.system-prompt-submit:hover,
.ranking-button:hover {
  background-color: #1a7ba8;
}

/* Style for the internal message content */
.internal-message {
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}

.internal-message:last-child {
  border-bottom: none;
}

.internal-message p {
  margin: 5px 0;
}

.message-content {
  padding: 5px 0;
}


/* Session list styles */
.session-list {
  list-style-type: none;
  padding: 0;
  margin: 0;
  overflow-y: auto;
}

.session-list li {
  padding: 10px;
  cursor: pointer;
  border-bottom: 1px solid #444;
  font-size: 14px;
  transition: background-color 0.2s ease;
}

.session-list li:hover {
  background-color: #ebf4fc;
}

.session-list li:not(:last-child) {
  margin-bottom: 8px;
}

.session-list li:last-child {
  margin-bottom: 0;
}

/* Examples container styles */
.examples-container {
  margin-top: 30vh;
  text-align: center;
}

.chat-examples {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  padding: 20px;
  gap: 20px;
  font-size: 16px;
  font-weight: normal !important;
  justify-content: center;
  align-items: stretch;
}

.chat-examples .chat-example-card {
  background-color: white;
  padding: 15px;
  border-radius: 8px;
  text-align: center;
  cursor: pointer;
  transition: transform 0.3s ease, background-color 0.3s ease;
  border: 1px solid #bbb;
  font-weight: normal;
}

.chat-examples .chat-example-card:hover {
  background-color: #aaa;
  transform: scale(1.05);
}

/* Mobile header and sidebar button */
.mobile-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background-color: #e8effa;
  padding: 10px 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 30px;
  z-index: 10;
}

.sidebar-button {
  display: none;
}

/* React Chat Elements customization */
.rce-button {
  font-family: 'Montserrat';
  background-color: #3c619c !important;
  margin-right: 10px !important;
}

.rce-container-input {
  background-color: #bed2f1;
  border-radius: 10px;
  height: 75px;
  color: #212121;
}

.rce-mbox-text {
  font-size: inherit;
}

.rce-input {
  background-color: transparent;
  margin-left: 20px;
}

.rce-input::placeholder {
  color: #5e5e5e;
}

/* Scrollbar styling */
::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #9f9f9f;
}

::-webkit-scrollbar-thumb:hover {
  background: #999;
}

.keepWhiteSpace {
  white-space: pre;
  text-wrap: auto;
}

.attachments {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 5px;
  gap: 5px;
}

.attachments-container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding: 10px;
  background: #f0f0f0;
  border-top: 1px solid #ddd;
}

.attachment-preview {
  display: inline-block;
  position: relative;
  width: 50px;
  height: 50px;
  border: 1px solid #ccc;
  border-radius: 4px;
  overflow: hidden;
}

.attachment-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.attachment-preview button {
  position: absolute;
  top: 2px;
  right: 2px;
  background: red;
  color: white;
  border: none;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  cursor: pointer;
  font-size: 10px;
}

/* Mobile responsiveness */
@media (max-width: 670px) {
  body, html {
    max-width: 100vw;
    width: 100vw;
    height: 100vh !important;
    /* Do not hide vertical scrolling globally; only control x-overflow */
    overflow-x: hidden !important;
    overflow-y: auto !important;
    padding: 0 !important;
    margin: 0 !important;
    position: static !important;
  }
  
  .dashboard-page-container {
    width: 100vw !important;
    max-width: 100vw !important;
    margin: 0 !important;
    padding: 0 !important;
    overflow-x: hidden !important;
    overflow-y: scroll !important;
    height: 100% !important;
    position: static !important;
    display: block !important;
  }
  
  .mobile-header {
    background-color: #e8effa;
    padding: 10px 5px 10px 5px;
    display: block;
    width: 100%;
  }

  .dashboard-page-container .sidebar {
    max-width: 250px !important;
    margin-top: 50px;
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    z-index: 1000;
  }

  .sidebar-logo {
    width: 80%;
  }

  .messages-container {
    max-width: 100vw !important;
    width: 100vw !important;
    max-height: calc(100vh - 180px);
    overflow-x: hidden !important;
    overflow-y: auto !important;
    margin: 0 !important;
    padding: 0 !important;
    left: 0 !important;
  }

  .dashboard-content {
    padding: 0 !important;
    width: 100vw !important;
    max-width: 100vw !important;
    overflow-x: hidden !important;
    overflow-y: auto !important;
    position: relative !important;
    margin: 0 !important;
    height: auto !important;
  }

  .sidebar-button {
    display: block;
    top: 10px;
    left: 10px;
    background-color: transparent;
    color: grey;
    padding: 0px;
    border: none;
    border-radius: 5px;
    font-size: 24px;
    z-index: 1100;
    cursor: pointer;
  }

  .sidebar.closed {
    transform: translateX(-100%);
    width: 250px;
  }

  .content {
    flex-direction: column !important;
    left: 0 !important;
    position: relative !important; 
    width: 100vw !important;
    max-width: 100vw !important;
    padding: 0 !important;
    margin: 0 !important;
    box-sizing: border-box !important;
    overflow-y: auto !important;
    height: auto !important;
  }

  .chat-container {
    width: 100vw !important;
    max-width: 100vw !important;
    padding: 0 !important;
    margin: 0 !important;
    left: 0 !important;
    box-sizing: border-box !important;
    overflow-y: auto !important;
    height: auto !important;
  }

  .input-container {
    width: 100% !important;
    max-width: 100% !important;
    padding: 0 !important;
    margin: 0 !important;
    left: 0 !important;
    position: relative !important;
    box-sizing: border-box !important;
    bottom: 0 !important;
    z-index: 100 !important;
  }
  
  /* Fix for chat messages */
  .message-container {
    width: 100vw !important;
    max-width: 100vw !important;
    padding: 8px !important;
    box-sizing: border-box !important;
  }

  .internal-content {
    display: none !important; /* Hide on mobile since it's causing the overflow */
    width: 0 !important;
    min-width: 0 !important;
    max-width: 0 !important;
    height: 0 !important;
    padding: 0 !important;
    margin: 0 !important;
    overflow: hidden !important;
    opacity: 0 !important;
    visibility: hidden !important;
  }

  .workgroup-dropdown {
    margin-top: 10px;
  }

  .dropdown-button {
    float: right;
  }

  .examples-container {
    margin-top: 10vh;
  }

  .chat-examples {
    gap: 5px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    align-items: end;
    justify-items: center;
    height: 40%;
  }

  .chat-examples .chat-example-card {
    height: -webkit-fill-available;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Dashboard.css"],"names":[],"mappings":"AAAA,MAAM;;AAEN;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,cAAc;EACd,+BAA+B;EAC/B,wCAAwC;EACxC,gBAAgB;EAChB,MAAM;EACN,SAAS;EACT,OAAO;EACP,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA,2BAA2B;AAC3B;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,2CAA2C;EAC3C,uBAAuB;EACvB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,eAAe,EAAE,oBAAoB;EACrC,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;EACb,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;EACX,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,2BAA2B;EAC3B,WAAW;EACX,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,uDAAuD;EACvD,gBAAgB;EAChB,yCAAyC;EACzC,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,uBAAuB,EAAE,wBAAwB;EACjD,WAAW;EACX,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,uBAAuB,EAAE,kCAAkC;EAC3D,wBAAwB;EACxB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB,EAAE,gDAAgD;AACvE;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB,EAAE,wCAAwC;AAC7D;;AAEA;EACE,WAAW;EACX,yBAAyB,EAAE,4BAA4B;EACvD,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,SAAO;EACP,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA,2CAA2C;AAC3C;EACE,mBAAmB;EACnB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;;AAGA,wBAAwB;AACxB;EACE,qBAAqB;EACrB,UAAU;EACV,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,6BAA6B;EAC7B,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,8BAA8B;EAC9B,aAAa;EACb,SAAS;EACT,eAAe;EACf,8BAA8B;EAC9B,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,2DAA2D;EAC3D,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA,qCAAqC;AACrC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA,sCAAsC;AACtC;EACE,yBAAyB;EACzB,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA,0BAA0B;AAC1B;EACE;IACE,gBAAgB;IAChB,YAAY;IACZ,wBAAwB;IACxB,qEAAqE;IACrE,6BAA6B;IAC7B,2BAA2B;IAC3B,qBAAqB;IACrB,oBAAoB;IACpB,2BAA2B;EAC7B;;EAEA;IACE,uBAAuB;IACvB,2BAA2B;IAC3B,oBAAoB;IACpB,qBAAqB;IACrB,6BAA6B;IAC7B,6BAA6B;IAC7B,uBAAuB;IACvB,2BAA2B;IAC3B,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,0BAA0B;IAC1B,cAAc;IACd,WAAW;EACb;;EAEA;IACE,2BAA2B;IAC3B,gBAAgB;IAChB,eAAe;IACf,OAAO;IACP,MAAM;IACN,SAAS;IACT,aAAa;EACf;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,2BAA2B;IAC3B,uBAAuB;IACvB,+BAA+B;IAC/B,6BAA6B;IAC7B,2BAA2B;IAC3B,oBAAoB;IACpB,qBAAqB;IACrB,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;IACrB,uBAAuB;IACvB,2BAA2B;IAC3B,6BAA6B;IAC7B,2BAA2B;IAC3B,6BAA6B;IAC7B,oBAAoB;IACpB,uBAAuB;EACzB;;EAEA;IACE,cAAc;IACd,SAAS;IACT,UAAU;IACV,6BAA6B;IAC7B,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,4BAA4B;IAC5B,YAAY;EACd;;EAEA;IACE,iCAAiC;IACjC,kBAAkB;IAClB,6BAA6B;IAC7B,uBAAuB;IACvB,2BAA2B;IAC3B,qBAAqB;IACrB,oBAAoB;IACpB,iCAAiC;IACjC,2BAA2B;IAC3B,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;IACvB,2BAA2B;IAC3B,qBAAqB;IACrB,oBAAoB;IACpB,kBAAkB;IAClB,iCAAiC;IACjC,2BAA2B;IAC3B,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,0BAA0B;IAC1B,qBAAqB;IACrB,oBAAoB;IACpB,kBAAkB;IAClB,6BAA6B;IAC7B,iCAAiC;IACjC,oBAAoB;IACpB,uBAAuB;EACzB;;EAEA,0BAA0B;EAC1B;IACE,uBAAuB;IACvB,2BAA2B;IAC3B,uBAAuB;IACvB,iCAAiC;EACnC;;EAEA;IACE,wBAAwB,EAAE,mDAAmD;IAC7E,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;IACvB,oBAAoB;IACpB,qBAAqB;IACrB,oBAAoB;IACpB,2BAA2B;IAC3B,qBAAqB;IACrB,6BAA6B;EAC/B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,QAAQ;IACR,aAAa;IACb,qCAAqC;IACrC,gBAAgB;IAChB,qBAAqB;IACrB,WAAW;EACb;;EAEA;IACE,8BAA8B;EAChC;AACF","sourcesContent":["body {}\n\n.dashboard-page-container {\n  background-color: #e8effa;\n  display: flex;\n  flex-direction: row;\n  height: 100vh;\n  overflow: hidden;\n}\n\n.dashboard-page-container .sidebar {\n  width: 250px;\n  min-width: 100px;\n  background-color: #fcfdfe;\n  padding: 20px;\n  color: #212121;\n  transition: transform 0.3s ease;\n  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);\n  overflow-y: auto;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1000;\n}\n\n.new-chat-button {\n  background: #279DD9 !important;\n  border: none;\n  border-radius: 5px;\n  box-sizing: border-box;\n  color: #fff;\n  cursor: pointer;\n  flex-direction: row;\n  font-size: 12px;\n  justify-content: center;\n  outline: none;\n  padding: 10px;\n  margin-top: 10px;\n  position: relative;\n  text-align: center;\n  transition: all .15s ease;\n}\n\n.sidebar-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  z-index: 999;\n}\n\n.sidebar-logo {\n  width: 66%;\n}\n\n/* Updated content layout */\n.content {\n  flex-grow: 1;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  padding: 20px;\n  padding-bottom: 0px;\n  max-width: none;\n  width: 100%;\n}\n\n.dashboard-content {\n  flex: 1;\n  min-width: 200px;\n  max-width: 100%;\n  display: flex;\n  flex-direction: column;\n  padding-right: 20px;\n}\n\n.sidebar-item {\n  margin-bottom: 20px;\n}\n\n.workgroup-dropdown label {\n  display: block;\n  font-weight: bold;\n  margin-bottom: 10px;\n}\n\n.workgroup-dropdown select {\n  width: 100%;\n  padding: 8px 12px;\n  font-size: 14px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  background-color: white;\n  color: #212121;\n  outline: none;\n}\n\n.workgroup-dropdown select:focus {\n  ring: 2px;\n  ring-color: #279DD9;\n  ring-opacity: 0.5;\n  border-color: #279DD9;\n}\n\n.workgroup-dropdown select:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.button {\n  background-color: #007bff;\n  color: white;\n  padding: 10px 20px;\n  border: none;\n  cursor: pointer;\n}\n\n.button:disabled {\n  background-color: #ccc;\n  cursor: not-allowed;\n}\n\n.error-message {\n  color: red;\n  font-size: 14px;\n}\n\n.dropdown-button {\n  position: fixed; /* Change to fixed */\n  top: 10px;\n  right: 10px;\n  background: none;\n  border: none;\n  font-size: 20px;\n  color: grey;\n  cursor: pointer;\n  padding: 5px;\n}\n\n.dropdown-menu {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  background-color: #333;\n  border-radius: 5px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n  padding: 10px;\n  z-index: 25;\n}\n\n.dropdown-item {\n  background: none;\n  border: none;\n  color: white;\n  padding: 8px 16px;\n  text-align: left;\n  width: 100%;\n  cursor: pointer;\n}\n\n.dropdown-item:hover {\n  background-color: #555;\n}\n\n.chat-container {\n  flex-grow: 1;\n  padding-right: 0;\n  overflow-y: auto;\n  padding-bottom: 10px;\n  width: 100%;\n  font-family: 'Hind';\n  line-height: 24px;\n}\n\n.messages-container {\n  overflow-y: auto;\n  flex-grow: 1;\n  padding: 10px;\n  height: calc(100vh - 150px);\n  width: 100%;\n  min-width: 200px;\n  z-index: 10;\n}\n\n.input-container {\n  padding: 10px;\n  bottom: 10px;\n  display: flex;\n  position: relative;\n  width: 100%;\n}\n\n.input-box {\n  border-radius: 15px;\n}\n\n.internal-content {\n  position: relative;\n  min-width: 250px;\n  width: 350px;\n  max-width: 100%;\n  height: calc(100vh - var(--topnav-height, 56px) - 70px);\n  margin-top: 10px;\n  border-left: 1px solid rgb(147, 200, 207);\n  box-sizing: border-box;\n  overflow: visible;\n  resize: horizontal;\n  padding: 15px;\n  display: flex;\n  flex-direction: column;\n}\n\n.internal-messages-container {\n  width: calc(100% - 2px); /* Account for borders */\n  height: 40%;\n  border: 1px solid #ccc;\n  background-color: #f9f9f9;\n  border-radius: 8px;\n  padding: 15px;\n  overflow-y: auto;\n  margin-bottom: 15px;\n  font-size: 13px;\n}\n\n.system-prompt-input {\n  width: calc(100% - 2px); /* Match internal messages width */\n  height: calc(60% - 15px);\n  display: flex;\n  flex-direction: column;\n}\n\n.internal-content::-webkit-resizer {\n  padding-right: 10px; /* Add some padding to separate from scrollbar */\n}\n\n.internal-content {\n  resize: horizontal;\n  padding-right: 5px;\n}\n\n.internal-messages-container {\n  margin-right: 2px; /* Add small margin to prevent overlap */\n}\n\n.system-prompt-input-box {\n  width: 100%;\n  height: calc(100% - 55px); /* Leave space for buttons */\n  resize: none;\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  font-size: 13px;\n  overflow-y: auto;\n  margin-bottom: 15px;\n}\n\n.system-prompt-buttons {\n  width: 100%;\n  height: 40px;\n  display: flex;\n  justify-content: space-between;\n  gap: 10px;\n  margin-top: auto;\n}\n\n.system-prompt-submit,\n.ranking-button {\n  flex: 1;\n  height: 40px;\n  padding: 8px 15px;\n  background-color: #279DD9;\n  color: white;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 13px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  white-space: nowrap;\n}\n\n.system-prompt-submit:hover,\n.ranking-button:hover {\n  background-color: #1a7ba8;\n}\n\n/* Style for the internal message content */\n.internal-message {\n  margin-bottom: 15px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid #eee;\n}\n\n.internal-message:last-child {\n  border-bottom: none;\n}\n\n.internal-message p {\n  margin: 5px 0;\n}\n\n.message-content {\n  padding: 5px 0;\n}\n\n\n/* Session list styles */\n.session-list {\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n  overflow-y: auto;\n}\n\n.session-list li {\n  padding: 10px;\n  cursor: pointer;\n  border-bottom: 1px solid #444;\n  font-size: 14px;\n  transition: background-color 0.2s ease;\n}\n\n.session-list li:hover {\n  background-color: #ebf4fc;\n}\n\n.session-list li:not(:last-child) {\n  margin-bottom: 8px;\n}\n\n.session-list li:last-child {\n  margin-bottom: 0;\n}\n\n/* Examples container styles */\n.examples-container {\n  margin-top: 30vh;\n  text-align: center;\n}\n\n.chat-examples {\n  display: flex;\n  flex-wrap: nowrap;\n  justify-content: space-between;\n  padding: 20px;\n  gap: 20px;\n  font-size: 16px;\n  font-weight: normal !important;\n  justify-content: center;\n  align-items: stretch;\n}\n\n.chat-examples .chat-example-card {\n  background-color: white;\n  padding: 15px;\n  border-radius: 8px;\n  text-align: center;\n  cursor: pointer;\n  transition: transform 0.3s ease, background-color 0.3s ease;\n  border: 1px solid #bbb;\n  font-weight: normal;\n}\n\n.chat-examples .chat-example-card:hover {\n  background-color: #aaa;\n  transform: scale(1.05);\n}\n\n/* Mobile header and sidebar button */\n.mobile-header {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  background-color: #e8effa;\n  padding: 10px 5px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  height: 30px;\n  z-index: 10;\n}\n\n.sidebar-button {\n  display: none;\n}\n\n/* React Chat Elements customization */\n.rce-button {\n  font-family: 'Montserrat';\n  background-color: #3c619c !important;\n  margin-right: 10px !important;\n}\n\n.rce-container-input {\n  background-color: #bed2f1;\n  border-radius: 10px;\n  height: 75px;\n  color: #212121;\n}\n\n.rce-mbox-text {\n  font-size: inherit;\n}\n\n.rce-input {\n  background-color: transparent;\n  margin-left: 20px;\n}\n\n.rce-input::placeholder {\n  color: #5e5e5e;\n}\n\n/* Scrollbar styling */\n::-webkit-scrollbar {\n  width: 10px;\n}\n\n::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #9f9f9f;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: #999;\n}\n\n.keepWhiteSpace {\n  white-space: pre;\n  text-wrap: auto;\n}\n\n.attachments {\n  display: flex;\n  flex-wrap: wrap;\n  margin-bottom: 5px;\n  gap: 5px;\n}\n\n.attachments-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  padding: 10px;\n  background: #f0f0f0;\n  border-top: 1px solid #ddd;\n}\n\n.attachment-preview {\n  display: inline-block;\n  position: relative;\n  width: 50px;\n  height: 50px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.attachment-preview img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.attachment-preview button {\n  position: absolute;\n  top: 2px;\n  right: 2px;\n  background: red;\n  color: white;\n  border: none;\n  border-radius: 50%;\n  width: 16px;\n  height: 16px;\n  cursor: pointer;\n  font-size: 10px;\n}\n\n/* Mobile responsiveness */\n@media (max-width: 670px) {\n  body, html {\n    max-width: 100vw;\n    width: 100vw;\n    height: 100vh !important;\n    /* Do not hide vertical scrolling globally; only control x-overflow */\n    overflow-x: hidden !important;\n    overflow-y: auto !important;\n    padding: 0 !important;\n    margin: 0 !important;\n    position: static !important;\n  }\n  \n  .dashboard-page-container {\n    width: 100vw !important;\n    max-width: 100vw !important;\n    margin: 0 !important;\n    padding: 0 !important;\n    overflow-x: hidden !important;\n    overflow-y: scroll !important;\n    height: 100% !important;\n    position: static !important;\n    display: block !important;\n  }\n  \n  .mobile-header {\n    background-color: #e8effa;\n    padding: 10px 5px 10px 5px;\n    display: block;\n    width: 100%;\n  }\n\n  .dashboard-page-container .sidebar {\n    max-width: 250px !important;\n    margin-top: 50px;\n    position: fixed;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    z-index: 1000;\n  }\n\n  .sidebar-logo {\n    width: 80%;\n  }\n\n  .messages-container {\n    max-width: 100vw !important;\n    width: 100vw !important;\n    max-height: calc(100vh - 180px);\n    overflow-x: hidden !important;\n    overflow-y: auto !important;\n    margin: 0 !important;\n    padding: 0 !important;\n    left: 0 !important;\n  }\n\n  .dashboard-content {\n    padding: 0 !important;\n    width: 100vw !important;\n    max-width: 100vw !important;\n    overflow-x: hidden !important;\n    overflow-y: auto !important;\n    position: relative !important;\n    margin: 0 !important;\n    height: auto !important;\n  }\n\n  .sidebar-button {\n    display: block;\n    top: 10px;\n    left: 10px;\n    background-color: transparent;\n    color: grey;\n    padding: 0px;\n    border: none;\n    border-radius: 5px;\n    font-size: 24px;\n    z-index: 1100;\n    cursor: pointer;\n  }\n\n  .sidebar.closed {\n    transform: translateX(-100%);\n    width: 250px;\n  }\n\n  .content {\n    flex-direction: column !important;\n    left: 0 !important;\n    position: relative !important; \n    width: 100vw !important;\n    max-width: 100vw !important;\n    padding: 0 !important;\n    margin: 0 !important;\n    box-sizing: border-box !important;\n    overflow-y: auto !important;\n    height: auto !important;\n  }\n\n  .chat-container {\n    width: 100vw !important;\n    max-width: 100vw !important;\n    padding: 0 !important;\n    margin: 0 !important;\n    left: 0 !important;\n    box-sizing: border-box !important;\n    overflow-y: auto !important;\n    height: auto !important;\n  }\n\n  .input-container {\n    width: 100% !important;\n    max-width: 100% !important;\n    padding: 0 !important;\n    margin: 0 !important;\n    left: 0 !important;\n    position: relative !important;\n    box-sizing: border-box !important;\n    bottom: 0 !important;\n    z-index: 100 !important;\n  }\n  \n  /* Fix for chat messages */\n  .message-container {\n    width: 100vw !important;\n    max-width: 100vw !important;\n    padding: 8px !important;\n    box-sizing: border-box !important;\n  }\n\n  .internal-content {\n    display: none !important; /* Hide on mobile since it's causing the overflow */\n    width: 0 !important;\n    min-width: 0 !important;\n    max-width: 0 !important;\n    height: 0 !important;\n    padding: 0 !important;\n    margin: 0 !important;\n    overflow: hidden !important;\n    opacity: 0 !important;\n    visibility: hidden !important;\n  }\n\n  .workgroup-dropdown {\n    margin-top: 10px;\n  }\n\n  .dropdown-button {\n    float: right;\n  }\n\n  .examples-container {\n    margin-top: 10vh;\n  }\n\n  .chat-examples {\n    gap: 5px;\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    align-items: end;\n    justify-items: center;\n    height: 40%;\n  }\n\n  .chat-examples .chat-example-card {\n    height: -webkit-fill-available;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
